export enum SaveOrderProductsEnum {
  NORESPONSE = 'NORESPONSE',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}
